import { EntityName } from '@adm/backend-entity';

import { DefaultAction, Models, UserRole } from '../../enums';

const Actions = {
  ...DefaultAction,
};

export const storyPermissions: Record<
  UserRole,
  { actions: Array<keyof typeof Actions>; subject: Models; fields?: Array<EntityName> }[]
> = {
  [UserRole.Admin]: [
    { actions: [Actions.read, Actions.create, Actions.delete, Actions.update], subject: Models.Story },
    { actions: [Actions.read], subject: Models.Stories },
  ],

  [UserRole.Operator]: [
    { actions: [Actions.read, Actions.create, Actions.delete, Actions.update], subject: Models.Story },
    { actions: [Actions.read], subject: Models.Stories },
  ],

  [UserRole.OperatorWithoutPBAccess]: [
    { actions: [Actions.read, Actions.create, Actions.delete, Actions.update], subject: Models.Story },
    { actions: [Actions.read], subject: Models.Stories },
  ],

  [UserRole.DeviceOperator]: [],

  [UserRole.OperatorReadAccess]: [
    { actions: [Actions.read], subject: Models.Story },
    { actions: [Actions.read], subject: Models.Stories },
  ],

  [UserRole.TtmOperator]: [],

  [UserRole.DeviceQualityOperator]: [],
};
